import { render, staticRenderFns } from "./ShopManage.vue?vue&type=template&id=a358f564&scoped=true"
import script from "./ShopManage.vue?vue&type=script&lang=js"
export * from "./ShopManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a358f564",
  null
  
)

export default component.exports